import { useState } from 'react';
import { Link } from 'react-router-dom';
import Panel from '~/components/Panel';
import CSCAssignmentDrawer from './CSCAssignmentDrawer';

interface CampaignRequest {
  id: number;
  patient_services_coordinator?: {
    person: {
      id: number;
      first_name: string;
      last_name: string;
    };
  };
}

interface CSC {
  id: number;
  first_name: string;
  last_name: string;
}

interface Props {
  csc?: CSC | null;
  campaignRequestId?: number;
  campaignRequest?: CampaignRequest;
  onCampaignRequestUpdate?: (updatedCampaignRequest: CampaignRequest) => void;
  metadata?: unknown;
}
const CscBlock: React.FC<Props> = ({ csc, campaignRequestId, campaignRequest, onCampaignRequestUpdate, metadata }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const bgColor = csc
    ? 'bg-[#e6f7f8] border-[#e6f7f8]'
    : 'bg-[#fdeaeb] border-[#fdeaeb]';

  return (
    <>
      <Panel addClasses={`${bgColor} flex-1`}>
        <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
          CSC
        </h2>
        <div
          className={`text-[38px]/[44px] ${
            csc ? 'font-bold' : ''
          } text-[#131212] ${csc ? '' : 'italic'}`}
        >
          {csc ? `${csc?.first_name} ${csc?.last_name}` : 'None Assigned'}
        </div>
        <div className='text-[16px]/[24px]'>
          {!csc && (
            <button
              className='text-[#F02D3A]'
              onClick={() => setIsDrawerOpen(true)}
            >
              Assign
            </button>
          )}
          {csc && (
            <Link className='mr-[16px] text-[#00AEB3]' to='#'>
              Message
            </Link>
          )}
          {csc && (
            <button
              className='text-[#00AEB3] hover:text-[#008B8F]'
              onClick={() => setIsDrawerOpen(true)}
            >
              Reassign
            </button>
          )}
        </div>
      </Panel>
      <CSCAssignmentDrawer 
        isOpen={isDrawerOpen} 
        setIsOpen={setIsDrawerOpen} 
        campaignRequestId={campaignRequestId}
        campaignRequest={campaignRequest}
        onCampaignRequestUpdate={onCampaignRequestUpdate}
        metadata={metadata}
      />
    </>
  );
};

export default CscBlock;
